import {apiSlice} from './apiSlice';

export const consolidatedFileApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createConsolidatedFile: builder.mutation({
      query: body => ({
        url: 'consolidated_file/',
        method: 'POST',
        body
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateConsolidatedFileMutation
} = consolidatedFileApi;
